<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-md-12 pt-2">
        <div class="input-group">
          <b-form-input v-model="search" placeholder="Pesquisar"></b-form-input>
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
        </div>
        <b-tabs class="mt-2">
          <b-tab title="Abertas" active>
            <b-card-text>
              <b-list-group style="max-width: 300px;">
                <b-list-group-item class="d-flex align-items-center" style="background-color: #efefef;">
                  <b-avatar rounded class="mr-3"></b-avatar>
                  <span class="mr-auto">João Paulo</span>
                  <b-badge>5</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar rounded variant="primary" text="MS" class="mr-3"></b-avatar>
                  <span class="mr-auto">Maria de Souza</span>
                  <b-badge>12</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar rounded variant="info" src="https://picsum.photos/250/250/?image=70" class="mr-3"></b-avatar>
                  <span class="mr-auto">Luiz Carlos Brigadeiro</span>
                  <b-badge>9</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar rounded class="mr-3" variant="success"></b-avatar>
                  <span class="mr-auto">Ricardo Silva</span>
                  <b-badge>5</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar rounded variant="info" src="https://placekitten.com/300/300" class="mr-3"></b-avatar>
                  <span class="mr-auto">Mario Jorge</span>
                  <b-badge>9</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar rounded variant="info" src="https://picsum.photos/250/250/?image=10" class="mr-3"></b-avatar>
                  <span class="mr-auto">Supermercado Preço Bom</span>
                  <b-badge>9</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex align-items-center">
                  <b-avatar rounded variant="info" src="https://picsum.photos/250/250/?image=20" class="mr-3"></b-avatar>
                  <span class="mr-auto">Auto Elétrica S/A</span>
                  <b-badge>9</b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-card-text>
          </b-tab>
          <b-tab title="Encerradas" disabled>
            <b-card-text>Tab contents 2</b-card-text>
          </b-tab>
        </b-tabs>
        <div class="pt-2">
          <b-button squared class="btn-third" style="width: 100%;"><i class="fas fa-headset"></i> Recebendo ligaçoes</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AtendimentoListaContato',
  data () {
    return {
      search: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/listacontato.vue